<template>
  <div id="banners-container">
    <div class="warning-banner p-3" v-if="store.altert">
      <div class="global-container">
        <p class="notif">
          <v-lazy-image alt="Alerte" :src="getPict('alert', 'svg', 'global')" />
        </p>
        <p class="marquee">
          <span
            ><strong>{{ store.altert }} </strong></span
          >
        </p>
      </div>
    </div>
    <div class="ad-banner p-3" v-if="store.banner.content">
      <div class="global-container">
        <div class="d-flex">
          <p class="notif">
            <v-lazy-image
              :src="getPict('notifications', 'svg', 'global')"
              alt="Publicité"
            />
          </p>
          <p class="marquee">
            <span
              ><strong>{{ store.banner.content }} </strong>
            </span>
          </p>
        </div>
        <p class="notif notif-ban">
          <a :href="validateUrl(store.banner.link)">{{
            store.banner.wordingCTA
          }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UtilMixin from "../../../mixins/UtilMixin";
import VLazyImage from "v-lazy-image/v2";
import { sendGraphQLRequest } from "../../../utils/sendGraphQLRequest.js";
import store from "../../../store/header";
import stores from "../../../store/header";
export default {
  name: "BannersModule",
  components: {
    VLazyImage,
  },
  mixins: [UtilMixin],
  data() {
    return {
      bannersContainerHeight: 0,
      store,
      route: "",
      cdn: process.env.VUE_APP_CDN,
    };
  },
  mounted() {
    this.envoyerRequeteAlert();
    this.envoyerRequeteBanner();
    this.route = this.getPartenaire().route;
    this.getAndSaveBannersHeight();
  },
  methods: {
    async envoyerRequeteAlert() {
      try {
        const { sendRequest } = sendGraphQLRequest();
        const queryAlert = `query {
            getAlert {
              content
            }
          }
        `;
        const resultatGetAlert = await sendRequest(queryAlert);
        stores.altert = resultatGetAlert.data.getAlert.content;
      } catch (error) {
        console.error("Erreur getAlert GraphQL :", error);
      }
    },
    async envoyerRequeteBanner() {
      try {
        const { sendRequest } = sendGraphQLRequest();
        const queryBanner = `query {
            getBanner {
              link
              wordingCTA
              content
            }
          }
        `;
        const resultatGetBanner = await sendRequest(queryBanner);
        stores.banner = resultatGetBanner.data.getBanner;
      } catch (error) {
        console.error("Erreur getBanner GraphQL :", error);
      }
    },
    validateUrl(url) {
      return url + this.route;
    },
    isMobile() {
      return screen.width <= 1200;
    },
    getAndSaveBannersHeight() {
      setTimeout(() => {
        if (this.store.altert)
          window.localStorage.setItem("bannerAlert", "exists");
        else localStorage.removeItem("bannerAlert");

        if (store.banner.content)
          window.localStorage.setItem("bannerContent", "exists");
        else localStorage.removeItem("bannerContent");
      }, 4000);
    },
  },
};
</script>
<style lang="scss">
@import "../../../assets/sass/modules/_bannersModule.scss";
</style>
